import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-search-pagination',
  templateUrl: './search-pagination.component.html',
  styleUrls: ['./search-pagination.component.css']
})
export class SearchPaginationComponent {

  @Input() totalSearchItems!: number;
  @Input() searchItemsPerPage: number = 10;
  @Input() SearchCurrentPage: number = 1;
  @Output() searchPageChanged: EventEmitter<number> = new EventEmitter<number>();


  get totalPages(): number {
    return Math.ceil(this.totalSearchItems / this.searchItemsPerPage);
  }

  get pages(): number[] {
    const pages = [];
    for (let i = 1; i <= this.totalPages; i++) {
      pages.push(i);
    }
    return pages;
  }

  changePage(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.SearchCurrentPage = page;
      this.searchPageChanged.emit(this.SearchCurrentPage);
    }
  }
}
